/**
  * vue-cal v3.11.0
  * (c) 2022 Antoni Andre <antoniandre.web@gmail.com>
  * @license MIT
  */
const e = ["Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday", "Sunday"], a = ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"], t = "Years", d = "Year", y = "Month", r = "Week", s = "Day", n = "Today", o = "No Event", l = "All day", M = "Delete", Y = "Create an event", u = "dddd MMMM D{S}, YYYY", D = { weekDays: e, months: a, years: "Years", year: "Year", month: "Month", week: "Week", day: "Day", today: "Today", noEvent: "No Event", allDay: "All day", deleteEvent: "Delete", createEvent: "Create an event", dateFormat: "dddd MMMM D{S}, YYYY" };
export {
  l as allDay,
  Y as createEvent,
  u as dateFormat,
  s as day,
  D as default,
  M as deleteEvent,
  y as month,
  a as months,
  o as noEvent,
  n as today,
  r as week,
  e as weekDays,
  d as year,
  t as years
};
